__turbopack_context__.v({
  "image": "_6VbxRq_image",
  "imageWrapper": "_6VbxRq_imageWrapper",
});
